import { useCallback, useState } from "react";
import { PLATFORM_USER_ACCESS_UI } from "../PlatformUserAccess.constants";

export const isInviteEmailFormatValid = (email) => {
  const trimmed = String(email ?? "").trim();
  return /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(trimmed);
};
export const useInviteEmailExists = ({ checkInviteEmail } = {}) => {
  const [checkingEmail, setCheckingEmail] = useState(false);

  const checkEmailOnBlur = useCallback(
    async (email) => {
      const trimmed = String(email ?? "").trim();
      if (!isInviteEmailFormatValid(trimmed)) {
        return { exists: false, fieldError: null };
      }
      if (typeof checkInviteEmail !== "function") {
        return { exists: false, fieldError: null };
      }

      setCheckingEmail(true);
      try {
        const result = await checkInviteEmail(trimmed);
        if (result?.error) {
          return {
            exists: false,
            fieldError: PLATFORM_USER_ACCESS_UI.inviteEmailValidationFailedError,
            validationFailed: true,
          };
        }
        const exists = Boolean(result?.exists);
        return {
          exists,
          fieldError: exists
            ? PLATFORM_USER_ACCESS_UI.inviteEmailAlreadyExistsError
            : null,
        };
      } finally {
        setCheckingEmail(false);
      }
    },
    [checkInviteEmail]
  );

  return {
    checkingEmail,
    checkEmailOnBlur,
  };
};
